import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { PopulationStore, PopulationState } from './population.store';
import { MemberQuery } from '../../account/member/member.query';
import { LoggingService } from '../../shared/services/core/logging.service';
import { map, switchMap, tap } from 'rxjs/operators';
import { Population } from './population.model';

@Injectable({ providedIn: 'root' })
export class PopulationQuery extends QueryEntity<PopulationState> {
  constructor(protected store: PopulationStore, private memberQuery: MemberQuery, private logger: LoggingService) {
    super(store);
  }

  selectUserInPopulation(populationNames: string[]) {
    return this.memberQuery
      .select((state) => (state.user ? state.user.populationId : 0))
      .pipe(
        map((pop) => {
          if (!pop) {
            return false;
          }
          return populationNames.includes(pop);
        })
      );
  }

  selectUserNotInPopulation(populationNames: string[]) {
    return this.selectUserInPopulation(populationNames).pipe(map((isIn) => !isIn));
  }

  userInPopulation(populationNames: string[] = []) {
    const population = this.memberQuery.getPopulationName();
    if (!population) {
      return false;
    }
    return populationNames.includes(population);
  }

  userNotInPopulation(populationNames: string[]) {
    return !this.userInPopulation(populationNames);
  }

  getCurrentPopulation(): Population {
    const user = this.memberQuery.getUserContext();
    var pop: Population = { PopulationId: parseInt(user.populationId), DisplayName: user.populationName as string, Description: user.populationName as string, ClubId: user.clubId }
    return pop
  }

  /**
 * @deprecated selects current population from deprecated PopulationStore
 */
  selectCurrentPopulation() {
    return this.memberQuery
      .select((state) => (state.user ? state.user.populationId : 0))
      .pipe(switchMap((id) => this.selectEntity(id)));
  }

  /**
 * @deprecated selects current population name from deprecated PopulationStore
 */
  selectCurrentPopulationDisplayName() {
    return this.selectCurrentPopulation().pipe(
      map((p) => {
        if (!p) {
          return undefined;
        }
        return p.DisplayName;
      })
    );
  }

  /**
 * @deprecated selects all current population names from deprecated PopulationStore
 */
  selectPopulations(populationNames: string[]) {
    return this.selectAll().pipe(
      map((pops) => pops.map((pop) => pop.DisplayName)),
      tap((pops) => {
        populationNames.forEach((x) => {
          if (!pops.includes(x)) {
            this.logger.error(`the population ${x} is not configured in the database`);
          }
        });
      })
    );
  }
}
